import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import { OfflineServerDto } from '../../../../core/dto/device/offline-servers/offline-server.dto'
import { ResourceName } from '../../../../core/ResourceName'
import { ConfirmDialog } from '../../../common/ConfirmDialog'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const OfflineServerForceReportStateButton = () => {
  const { record: server, loading } = useShowContext<OfflineServerDto>()
  const classes = useStyles()
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const notify = useNotify()

  const handleMutate = async () => {
    setConfirmDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('forceReportState'),
        resource: ResourceName.OFFLINE_SERVERS,
        payload: {
          id: server?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
  }

  const handleConfirm = () => {
    setConfirmDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={confirmDialogOpen}
        confirm={handleMutate}
        source="forceReportState"
        cancel={() => setConfirmDialogOpen(false)}
        action="set"
        resource={ResourceName.OFFLINE_SERVERS}
      />
      <Button
        variant="contained"
        onClick={handleConfirm}
        color="primary"
        className={classes.button}
        label="resources.offline-servers.actions.forceReportState"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.OFFLINE_SERVERS_FORCE_REPORT_STATE_BUTTON) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
